import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function StepLayout({ title, onBack, children }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', p: 4, display: 'flex', flexDirection: 'column' }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 4 }}>
        <IconButton
          size="large"
          onClick={onBack ?? (() => navigate(-1))}
          aria-label="Retour"
        >
          <ArrowBackIcon fontSize="large" />
        </IconButton>
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
      </Stack>
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  );
}
